document.addEventListener('DOMContentLoaded', function() {

    // -------------------------------
    // 🔹 HELPERS
    // -------------------------------
    function fetchJSON(url) {
        return fetch(url).then(r => {
            if (!r.ok) throw new Error('Network response was not ok');
            return r.json();
        });
    }

    // Ελέγχει αν στο backend το συγκεκριμένο itemKey έχει την expectedQuantity
    function verifyCartQuantity(itemKey, expectedQuantity) {
        return fetchJSON('/cart.js')
            .then(cart => {
                const found = cart.items.find(it => it.key === itemKey);
                const qty = found ? found.quantity : 0;
                return qty === expectedQuantity;
            })
            .catch(err => {
                console.error('verifyCartQuantity error:', err);
                // Αν υπάρχει λάθος δικτύου, επιστρέφουμε false (ώστε να κάνουμε reload)
                return false;
            });
    }

    // -------------------------------
    // 🔹 CART COUNT UPDATE
    // -------------------------------
    function updateCartCount() {
        fetchJSON('/cart.js')
            .then(cart => {
                const cartCountBubbles = document.querySelectorAll('#cart-count-bubble');
                cartCountBubbles.forEach(cartCountBubble => {
                    if (cart.item_count > 0) {
                        cartCountBubble.style.display = 'block';
                        cartCountBubble.textContent = cart.item_count;
                    } else {
                        cartCountBubble.style.display = 'none';
                    }
                });
            })
            .catch(error => console.error("Error fetching cart data:", error));
    }

    // -------------------------------
    // 🔹 CART DRAWER UPDATE
    // -------------------------------
    function updateCartDrawer() {
        return fetch('/cart')
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newCartContent = doc.querySelector('.cart-drawer__body');
                if (newCartContent) {
                    const current = document.querySelector('.cart-drawer__body');
                    if (current) current.innerHTML = newCartContent.innerHTML;
                    attachAllListeners();
                }
            })
            .catch(error => console.error("Error updating cart drawer:", error));
    }

    // -------------------------------
    // 🔹 OPEN CART DRAWER
    // -------------------------------
    function openCartDrawer() {
        const cartDrawer = document.getElementById('cart-drawer');
        if (cartDrawer) {
            cartDrawer.classList.add('is-open');
            document.body.classList.add('cart-drawer-open');
        }
    }

    // -------------------------------
    // 🔹 CONFLICT CHECKING (το κρατάμε)
    // -------------------------------
    function checkCartAndUpdate() {
        fetchJSON("/cart.js")
            .then(cart => {
                let hasProduct1 = false;
                let hasProduct2 = false;
                let product2Key = null;

                cart.items.forEach(item => {
                    if (
                        item.product_id === 9921045790904 ||
                        item.product_id === 9174846374072 ||
                        item.product_id === 9990906609848 ||
                        item.product_id === 10015832735928 ||
                        item.product_id === 10107214987448 ||
                        item.product_id === 10107048394936 ||
                        item.product_id === 10245347606712 ||
                        item.product_id === 10245346459832
                    ) {
                        hasProduct1 = true;
                    }
                    if (item.product_id === 9176422482104) {
                        hasProduct2 = true;
                        product2Key = item.key;
                    }
                });

                if (hasProduct1 && hasProduct2 && product2Key) {
                    console.log("❌ Conflict detected! Removing gift product...");
                    removeFromCart(product2Key);
                }
            })
            .catch(error => console.error("Error checking cart:", error));
    }

    function removeFromCart(itemKey) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: itemKey, quantity: 0 })
        })
        .then(r => r.json())
        .then(() => {
            console.log('Conflicting item removed, reloading...');
            location.reload();
        })
        .catch(err => console.error('Error removing item from cart:', err));
    }

    // -------------------------------
    // 🔹 ADD TO CART HANDLER
    // -------------------------------
    function handleAddToCartClick(event) {
        event.preventDefault();
        const button = event.currentTarget;
        const form = button.closest('form');
        if (!form) return;

        // Prevent double-click issues
        if (button.disabled) return;
        button.disabled = true;
        setTimeout(() => button.disabled = false, 2000);

        const formData = new FormData(form);
        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity') || '1', 10);

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ id: variantId, quantity: quantity })
        })
        .then(response => {
            if (!response.ok) return response.json().then(err => { throw err; });
            return response.json();
        })
        .then(() => {
            updateCartCount();
            // Ενημέρωση drawer πρώτα
            return updateCartDrawer();
        })
        .then(() => {
            openCartDrawer();
            // Έλεγχος conflicts μετά το add
            // Πρώτα τρέχουμε το conflict check, αν αυτό αφαιρέσει κάτι θα κάνει reload
            // Αν όχι, θα βεβαιωθούμε ότι το backend έχει την αναμενόμενη κατάσταση
            setTimeout(() => {
                checkCartAndUpdate();
                setTimeout(() => location.reload(), 700);
            }, 500);
        })
        .catch(error => {
            console.error("Error adding item to cart:", error);
        });
    }

    // -------------------------------
    // 🔹 ADD GIFT BAG
    // -------------------------------
    function handleAddGiftBag(event) {
        event.preventDefault();
        const giftBagVariantId = '48421465620664';
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ id: giftBagVariantId, quantity: 1 })
        })
        .then(response => {
            if (!response.ok) return response.json().then(err => { throw err; });
            return response.json();
        })
        .then(() => {
            // εδώ κρατάμε refresh όπως προηγουμένως για να εμφανιστεί σωστά
            window.location.href = window.location.pathname;
        })
        .catch(error => console.error('Error adding gift bag to cart:', error));
    }

    // -------------------------------
    // 🔹 DECREASE QUANTITY (ΣΤΑΘΕΡΗ ΛΕΙΤΟΥΡΓΙΑ + έξυπνο reload)
    // -------------------------------
    function handleDecreaseQuantityClick(event) {
        event.preventDefault();
        const button = event.currentTarget;
        const cartItem = button.closest('.cart__item');
        if (!cartItem) return;

        const quantityInput = cartItem.querySelector('.cart__item__quantity-field');
        if (!quantityInput) return;

        const itemKey = quantityInput.getAttribute('data-item'); // από το HTML σου
        const currentQuantity = parseInt(quantityInput.value, 10) || 0;
        const newQuantity = currentQuantity - 1;

        // Αν πάει στο 0 → αφαίρεση και reload
        if (newQuantity <= 0) {
            fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({ id: itemKey, quantity: 0 })
            })
            .then(r => r.json())
            .then(() => {
                // Ενημέρωση UI
                cartItem.remove();
                updateCartCount();
                return updateCartDrawer();
            })
            .then(() => {
                // ΜΙΚΡΗ καθυστέρηση για να ολοκληρώσει το backend τη διαγραφή
                setTimeout(() => location.reload(), 700);
            })
            .catch(err => console.error('Error removing item:', err));
            return;
        }

        // Κανονική μείωση (π.χ. 3 → 2). Στέλνουμε το αίτημα και ΜΟΝΟ αφού επιβεβαιώσουμε, αποφασίζουμε για reload
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ id: itemKey, quantity: newQuantity })
        })
        .then(r => r.json())
        .then(() => {
            // Προσπαθούμε να επαληθεύσουμε ότι το backend έχει την αναμενόμενη ποσότητα.
            // Αν ναι → απλά ενημερώνουμε το UI. Αν όχι → reload.
            return verifyCartQuantity(itemKey, newQuantity)
                .then(isCorrect => {
                    if (isCorrect) {
                        // Ενημέρωση UI χωρίς reload
                        quantityInput.value = newQuantity;
                        updateCartCount();
                        return updateCartDrawer();
                    } else {
                        // Αν δεν ενημερώθηκε σωστά, κάνουμε reload για ασφάλεια
                        console.warn('Quantity mismatch after change — reloading to sync.');
                        setTimeout(() => location.reload(), 500);
                    }
                });
        })
        .catch(err => {
            console.error('Error updating item quantity:', err);
            // Σε περίπτωση σφάλματος δικτύου, κάνουμε reload για να μη μείνει inconsistent ο drawer
            setTimeout(() => location.reload(), 500);
        });
    }

    // -------------------------------
    // 🔹 REMOVE ITEM (από το κουμπί Αφαίρεση)
    // -------------------------------
    function handleRemoveItemClick(event) {
        event.preventDefault();
        const link = event.currentTarget;
        const lineItemId = link.getAttribute('data-id'); // χρησιμοποιούμε το data-id (key)
        const cartItem = link.closest('.cart__item');
        if (!cartItem) return;

        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ id: lineItemId, quantity: 0 })
        })
        .then(r => r.json())
        .then(() => {
            cartItem.remove();
            updateCartCount();
            return updateCartDrawer();
        })
        .then(() => {
            setTimeout(() => location.reload(), 600);
        })
        .catch(error => console.error("Error removing item from cart:", error));
    }

    // -------------------------------
    // 🔹 HIDE BUTTON WHEN RESTRICTED PRODUCT EXISTS
    // -------------------------------
    function checkCartAndHideButton() {
        fetchJSON('/cart.js')
            .then(cart => {
                let hasProduct1 = false;

                cart.items.forEach(item => {
                    if (
                        item.product_id === 9921045790904 ||
                        item.product_id === 9174846374072 ||
                        item.product_id === 9990906609848 ||
                        item.product_id === 10015832735928 ||
                        item.product_id === 10107214987448 ||
                        item.product_id === 10107048394936 ||
                        item.product_id === 10245347606712 ||
                        item.product_id === 10245346459832
                    ) {
                        hasProduct1 = true;
                    }
                });

                if (hasProduct1 && document.body.id === "ouaou-mascara-δωρο") {
                    document.querySelectorAll(".product__submit__add").forEach(button => {
                        button.style.display = "none";
                    });
                }
            })
            .catch(error => console.error("Error fetching cart:", error));
    }

    // -------------------------------
    // 🔹 EVENT ATTACHERS
    // -------------------------------
    function attachAddToCartListeners() {
        document.querySelectorAll('.product__submit__add').forEach(button => {
            button.removeEventListener('click', handleAddToCartClick);
            button.addEventListener('click', handleAddToCartClick);
        });
    }

    function attachDecreaseQuantityListeners() {
        document.querySelectorAll('.cart__item__quantity-minus').forEach(button => {
            button.removeEventListener('click', handleDecreaseQuantityClick);
            button.addEventListener('click', handleDecreaseQuantityClick);
        });
    }


    function attachRemoveItemListeners() {
        document.querySelectorAll('.cart__item__remove').forEach(link => {
            link.removeEventListener('click', handleRemoveItemClick);
            link.addEventListener('click', handleRemoveItemClick);
        });
    }

    function attachAllListeners() {
        attachAddToCartListeners();
        attachDecreaseQuantityListeners();
        attachRemoveItemListeners();

        const giftBagForm = document.getElementById('add-gift-bag-form');
        if (giftBagForm) {
            giftBagForm.removeEventListener('submit', handleAddGiftBag);
            giftBagForm.addEventListener('submit', handleAddGiftBag);
        }
    }

    // -------------------------------
    // 🔹 INITIALIZATION
    // -------------------------------
    attachAllListeners();

    const cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer) {
        const observer = new MutationObserver(attachAllListeners);
        observer.observe(cartDrawer, { childList: true, subtree: true });
    }

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('open_cart')) {
        updateCartDrawer().then(openCartDrawer);
    } else {
        updateCartCount();
    }

    // Initial checks on page load
    checkCartAndUpdate();
    checkCartAndHideButton();
});
